import '../../styles/Home.scss';
import { useState } from 'react';
import { Box, Snackbar } from '@mui/material';
import SmsIcon from '@mui/icons-material/Sms';
import AddIcon from '@mui/icons-material/Add';
import SelectMenu from '../../components/chat/SelectMenu';
import DrawerChatLog from '../../components/chat/home/DrawerChatLog';
import TableListChat from '../../components/chat/home/TableListChat';
import { ChatLogItem, Drive } from '../../models/interfaces';
import React, { useEffect } from 'react';
import {
  addNewChat,
  deleteSelectedChat,
  getChatDetail,
  getChatList,
  updateTitle,
} from '../../services/chat-service';
import { STATUS_CODE } from '../../utils/constants';

export default function Home() {
  const [listChat, setListChat] = useState<Drive[]>([]);
  const [chatLog, setChatLog] = React.useState<ChatLogItem[]>([]);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [openChatDetail, setOpenChatDetail] = React.useState(false);
  const [openCopyToClibboard, setOpenCopyToClibboard] = React.useState(false);
  // Loading manage
  const [isLoadingChatDetail, setIsLoadingChatDetail] = React.useState(false);
  const [isLoadingListChat, setIsLoadingListChat] = React.useState(false);
  const [selectedId, setSelectedId] = useState<string>();

  const addMenuItems = [
    {
      text: '新規',
      icon: <SmsIcon />,
      callback: () => handAddNewChat(),
    },
  ];

  const handleMenuRowClick = (id: string) => {
    setSelectedIds([id]);
    setSelectedId(id);
  };

  const handleRowClick = (id: string) => {
    setSelectedIds([id]);
    handleOpenChatDetail(id);
    setSelectedId(id);
  };

  const handleContextMenuClick = () => {
    // console.log('handleMenuRowClick', selectedIds);
    // setSelectedIds([id]);
    // setSelectedId(id);
  };

  const handleCheckBoxChange = (id: string) => {
    let newSelectedIds = [...selectedIds];
    if (selectedIds.includes(id)) {
      newSelectedIds = selectedIds.filter((item) => item !== id);
    } else {
      newSelectedIds.push(id);
    }
    setSelectedIds(newSelectedIds);
  };

  const handleOpenChatDetail = (id: string) => {
    setOpenChatDetail(true);
    handleGetChatDetail(id);
  };

  const handleCloseChatDetail = () => {
    setOpenChatDetail(false);
  };

  const handAddNewChat = async () => {
    try {
      const res = await addNewChat({ title: '無題', content_type: 'CHAT' });
      if (res.status === STATUS_CODE.CREATED) {
        await handleGetChatList();
        handleRowClick(res.data.insert_id);
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    }
  };

  const handleGetChatList = async () => {
    try {
      setIsLoadingListChat(true);
      const res = await getChatList();
      if (res.status === STATUS_CODE.SUCCESS) {
        setListChat(res.data);
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    } finally {
      setIsLoadingListChat(false);
    }
  };

  const handleGetChatDetail = async (id: string) => {
    try {
      setChatLog([]);
      setIsLoadingChatDetail(true);
      const res = await getChatDetail(id);
      if (res.status === STATUS_CODE.SUCCESS) {
        setChatLog(res.data);
      }
    } catch (error) {
      setChatLog([]);
      // todo handle error
    } finally {
      setIsLoadingChatDetail(false);
    }
  };

  const handDeleteChat = async () => {
    try {
      setIsLoadingListChat(true);
      const res = await deleteSelectedChat(selectedIds);
      if (res.status === STATUS_CODE.SUCCESS) {
        handleGetChatList();
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    } finally {
      setIsLoadingListChat(false);
    }
  };

  const handUpdateTitleChat = async (id: string, title: string) => {
    try {
      setIsLoadingListChat(true);
      const res = await updateTitle(id, title);
      if (res.status === STATUS_CODE.SUCCESS) {
        handleGetChatList();
      } else {
        // todo handle error
      }
    } catch (error) {
      // todo handle error
    } finally {
      setIsLoadingListChat(false);
    }
  };

  useEffect(() => {
    handleGetChatList();
  }, []);

  return (
    <div className="home-layout">
      <Box sx={{ flexGrow: 1, height: '100%' }}>
        <SelectMenu
          menuItems={addMenuItems}
          idButton="addNewBtn"
          idMenu="addNewMenu"
          textButton={'新規'}
          className="btn-add"
          iconButton={<AddIcon />}
        />
        <TableListChat
          dataSource={listChat}
          handleRowClick={handleRowClick}
          handleCheckBoxChange={handleCheckBoxChange}
          selectedIds={selectedIds}
          onAddNewChat={handAddNewChat}
          loading={isLoadingListChat}
          handDeleteChat={handDeleteChat}
          handleMenuClick={handleMenuRowClick}
          handUpdateTitleChat={handUpdateTitleChat}
          handleContextMenuClick={handleContextMenuClick}
        />

        {openChatDetail && (
          <DrawerChatLog
            chatLogs={chatLog}
            handleDrawerClose={handleCloseChatDetail}
            setChatLog={setChatLog}
            chatId={selectedId as string}
            loading={isLoadingChatDetail}
            setOpenCopyToClibboard={setOpenCopyToClibboard}
          />
        )}
      </Box>
      <Snackbar
        message="クリップボードにコピーされました"
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={2000}
        onClose={() => setOpenCopyToClibboard(false)}
        open={openCopyToClibboard}
      />
    </div>
  );
}
